import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { TagService } from '../../task/tag/tag.service';
import { TagJoinService } from './tag-join.service';
import { AlertService } from '@app/_services';
import { TagAddModalComponent } from '@app/_components/task/tag/tag-add-modal/tag-add-modal.component';
import { TagSelectModalComponent } from './tag-select-modal/tag-select-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';




@Component({
    standalone: false,
    selector: 'app-tag-join-select',
    templateUrl: './tag-join.component.html',
    styleUrls: ['./tag-join.component.css']
})
export class TagJoinComponent implements OnInit, OnChanges
{
	texts: string[] = [];

	tagSuggestions: string[];
	availableTags: any[];
	validTags:any[];

	tagSelectForm: UntypedFormGroup;

	tagAddModalDialogRef: MatDialogRef<TagAddModalComponent>;

	@Output() messageEvent = new EventEmitter<string>();

	@Input() tags;

	@Input() tagType: number;
	// inputs
	@Input() tagSource: number;
	@Input() tagSourceId: number;
	@Input() fetchBySourceId: number;
	@Input() viewOnly: boolean;
	@Input() isPublicAndPublish: boolean;
	@Output() tagsSelectedEvent = new EventEmitter<any>();



	constructor(
		private formBuilder: UntypedFormBuilder,
		private reportService: ReportService,
		private tagService: TagService,
		private tagJoinService: TagJoinService,
		private alertService: AlertService,
		private dialog: MatDialog) { }

	ngOnInit()
	{
		this.tagSelectForm = this.formBuilder.group({
			tagJoin: [this.tags || []],
			tagSource: this.tagSource,
			tagSourceId: this.tagSourceId
		});
		// Use preloaded tags when parent provides them (e.g. task page) so popup shows immediately
		if (this.tags && Array.isArray(this.tags) && this.tags.length > 0) {
			this.tagSelectForm.patchValue({ tagJoin: this.tags });
		} else {
			this.findTags(this.tagType ?? 4);
		}
		this.findAllTags();
		if(this.isPublicAndPublish) {
			this.tagSelectForm.controls['tagJoin'].disable();
			this.viewOnly = true;
		}
	}

	async findTags(tagType) {
		let ths=this;
		this.tagJoinService.getTagByType(tagType, this.tagSource, this.tagSourceId).pipe(first()).subscribe(
			async (res:any) =>
			{
				if(res.data.tagJoin) {
					await this.getDuplicatesTags(res.data.tagJoin) ;
					res.data.tagJoin=this.validTags;
					var tags = [];
						res.data.tagJoin.forEach(tag => {
							this.tagService.findById(tag.tagId).subscribe(
								(res2:any) =>
								{
									let tag:any = {};
									tag['name'] = res2.data.tag.name;
									tag['visibility'] = res2.data.tag.visibility;
									tag['tagType'] = res2.data.tag.tagType;
									tag['tagId'] = res2.data.tag.tagId;
									tags.push(tag);
									if (tagType == 8){
									let x= this.availableTags.filter(d =>d.name === res2.data.tag.name);
									if (x.length>0) {
										tag['breezewayTagId'] = x[0]['breezewayTagId'];
									  }
									}
									this.tagSelectForm.patchValue({ tagJoin: tags });
								},
								error => {}
								);
							});
				}
			},
			error =>
			{
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

	// for each letter typed in autocomplete...
	onKeyInput(event)
	{
		let query = event.query;
		this.findTagsWith(query);
		return this.tagSuggestions;
	}

	// not used.
	onKeyUp(event: KeyboardEvent)
	{
		if (event.key === 'Enter')
		{
			let tokenInput = event.srcElement as any;
			console.log('tokenInput ' + JSON.stringify(tokenInput.value));
			if (tokenInput.value)
			{
				this.tagSuggestions.push(tokenInput.value);
				tokenInput.value = '';
			}
		}
	}

	onSelect(event)
	{
		// assemble the payload manually since we are using primeng
		console.log('onSelect: ' + JSON.stringify(event));
		const selectedTagId = this.extractTagId(event);
		if (selectedTagId == null)
		{
			console.warn('Tag selection missing tagId:', event);
			return;
		}
		let data: any = {};
		data.tagId = selectedTagId;
		data.tagSource = this.tagSource;
		data.tagSourceId = this.tagSourceId;
    switch ( data.tagSource ){
      case 40:
          data.taskId = this.tagSourceId;
        break;
    }
		console.log('onSelect: ' + JSON.stringify(data));
		if ( !this.viewOnly){
			this.addTagJoin(data);
		}
		this.tagsSelectedEvent.emit(this.tagSelectForm.value.tagJoin);
	}


	onUnselect(event)
	{
		// assemble the payload manually since we are using primeng
		let data: any = {};
		data.tagSource = this.tagSource;
		data.tagSourceId = this.tagSourceId;
		const selectedTagId = this.extractTagId(event);
		if (selectedTagId == null)
		{
			console.warn('Tag unselect missing tagId:', event);
			return;
		}
		data.tagId = selectedTagId;
		console.log('onUnselect: ' + JSON.stringify(data));
		console.log('onUnselect: ' + JSON.stringify(this.tagSelectForm.value.tagJoin));
		if ( !this.viewOnly){
			this.deleteTagJoin(data);
		}
		this.tagsSelectedEvent.emit(this.tagSelectForm.value.tagJoin);
	}

	findTagsWith(queryString: string)
	{
		if (this.fetchBySourceId){
			this.reportService.findTagsWithSource(queryString, this.tagSourceId, this.fetchBySourceId).pipe(first()).subscribe(

				data =>
				{
					this.tagSuggestions = [];
					this.tagSuggestions = data.data.tagSummaryList;
				},
				error =>
				{
					this.alertService.error(error);
				},
				() =>
				{ }
			);
		}
		else {
			this.reportService.findTagsWith(queryString, this.tagSourceId).pipe(first()).subscribe(

				data =>
				{
					// console.log('tags are: ' + JSON.stringify(data));
					this.tagSuggestions = [];
					this.tagSuggestions = data.data.tagSummaryList;
				},
				error =>
				{
					this.alertService.error(error);
				},
				() =>
				{ }
			);
		}

	}

	findAllTags()
	{
		// For Reservation component, we shows multiselect dropdwon hence fetch all tags available for Reservation
		if(this.tagSource != null && this.tagSource == 90)
		{
			this.reportService.findTagsWithTagType(this.tagType).pipe(first()).subscribe(

				data =>
				{
					// console.log('tags are: ' + JSON.stringify(data));
					this.availableTags = [];
					this.availableTags = data.data.tagSummaryList;
					this.findTags(8);
				},
				error =>
				{
					this.alertService.error(error);
				},
				() =>
				{ }
			);
		}
	}

    async  getDuplicatesTags(arr:any): Promise<void>{
		this.validTags= [];
		let invalidTags:any=[];
		arr.forEach(yy=>{
			let q= this.validTags.find(i => i.tagId === yy.tagId);
			if (q==undefined)this.validTags.push(yy);
			else{
				invalidTags.push(yy.tagJoinId);
			}
		});
		if (this.validTags!=null && this.validTags.length>0 && invalidTags!=null && invalidTags.length>0){
			//Delete duplicate Tags api call
			let data: any={};
			data.tagSource = this.tagSource;
			data.tagSourceId = this.tagSourceId;
			data.tagJoinIds =invalidTags;
			this.validTags.forEach(ss=>{
				let x= arr.find(d =>d.tagJoinId === ss.tagJoinId);
				if (x!=undefined){
					let data: any = {};
					data.name = x.name;
					data.tagSource = x.tagSource;
					data.tagSourceId = x.tagSourceId;
					data.tagId = x.tagId;
					if (this.tagSelectForm.value.tagJoin==null){
						this.tagSelectForm.value.tagJoin=[];
					}
					this.tagSelectForm.value.tagJoin.push(data);
					this.tagsSelectedEvent.emit(this.tagSelectForm.value.tagJoin);
				}
				
			})
			this.tagJoinService.deleteMultipleTagJoin(data).pipe(first()).subscribe(
				data =>
				{
					// console.log('tags are: ' + JSON.stringify(data));
						this.alertService.success(data, true);
					
				},
				error =>
				{
					// console.log('reports LIST!: ' + JSON.stringify(error));
					this.alertService.error(error);
					
				}
			);
			
			
		}else{
		
	}
	
	
	
	}

	onTagChange(event)
	{
		console.log('onTagChange: ' + JSON.stringify(event.value));
		const itemTagId = this.extractTagId(event?.itemValue);
		if (itemTagId == null)
		{
			console.warn('Tag change missing item tagId:', event);
			return;
		}
		var checked = false;
		event.value.forEach(element => {
			if(this.extractTagId(element) == itemTagId)
			{
				checked = true;
				return;
			}
		});
		if(checked)
		{
			let data: any = {};
			data.tagId = itemTagId;
			data.tagSource = this.tagSource;
			data.tagSourceId = this.tagSourceId;
			console.log('onSelect: ' + JSON.stringify(data));
			this.addTagJoin(data);
			this.tagsSelectedEvent.emit(this.tagSelectForm.value.tagJoin);
		}
		else
		{
			let data: any = {};
			data.tagSource = this.tagSource;
			data.tagSourceId = this.tagSourceId;
			data.tagId = itemTagId;
			console.log('onUnselect: ' + JSON.stringify(data));
			console.log('onUnselect: ' + JSON.stringify(this.tagSelectForm.value.tagJoin));
			this.deleteTagJoin(data);
			this.tagsSelectedEvent.emit(this.tagSelectForm.value.tagJoin);
		}
	}

	private extractTagId(payload: any): number | string | null
	{
		if (payload == null) {
			return null;
		}
		const candidate = payload?.value ?? payload;
		return candidate?.tagId ?? candidate?.id ?? null;
	}

	addTagJoin(tag)
	{
		this.tagJoinService.addTagJoins(tag).pipe(first()).subscribe(

			data =>
			{
				// console.log('tags are: ' + JSON.stringify(data));
				this.alertService.success(data, true);
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

	deleteTagJoin(tag)
	{
		this.tagJoinService.deleteTagJoin(tag).pipe(first()).subscribe(

			data =>
			{
				// console.log('tags are: ' + JSON.stringify(data));
				this.alertService.success(data, true);
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

	/**
     *
     * method to update parent component
     */

	openTagAddModalDialog()
	{
		{
			this.tagAddModalDialogRef = this.dialog.open(TagAddModalComponent, {
				hasBackdrop: true
			});
			let instance = this.tagAddModalDialogRef.componentInstance;

			// pass the tagType through from the helper to the popup.
			instance.tagType = this.tagType;

			// Pass distinct categories from available tags for the dropdown
			if (this.availableTags)
			{
				const cats = [...new Set(this.availableTags.filter(t => t.tagGroupCategory).map(t => t.tagGroupCategory))].sort();
				instance.tagGroupCategories = cats;
			}
		}
	}
	openTagSelectModal()
	{
		const dialogRef = this.dialog.open(TagSelectModalComponent, {
			hasBackdrop: true,
			width: '600px',
			data: {
				availableTags: this.availableTags,
				selectedTags: this.tagSelectForm.value.tagJoin || [],
				tagSource: this.tagSource,
				tagSourceId: this.tagSourceId,
				tagType: this.tagType
			}
		});
		dialogRef.afterClosed().subscribe(result =>
		{
			if (result)
			{
				this.tagSelectForm.patchValue({ tagJoin: result });
				this.tagsSelectedEvent.emit(result);
			}
			// Refresh availableTags so reopening the popup includes any newly added tags
			this.findAllTags();
		});
	}

	ngOnChanges()
	{
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no tagSourceId.  This sets the tagSourceId when add is successful.
		if (this.tagSelectForm !== undefined)
		{
			this.tagSelectForm.patchValue({ tagSourceId: this.tagSourceId });
		}
	}
}
